import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getdataByIdim_transaction_dependent = (id) => {
  return httpClient.get(server.IM_TRANSACTION_DEPENDENT + `/getbyid/${id}`);
};

export const getAllim_transaction_dependent_Company = (query) => {
    return httpClient.get(server.IM_TRANSACTION_DEPENDENT + `/getAllim_transaction_dependent_Company`, query);
  };

export const addim_transaction_dependent = (data) => {
  return httpClient.post(server.IM_TRANSACTION_DEPENDENT + `/`, data);
};

export const updateim_transaction_dependent = (id,data) => {
  return httpClient.put(server.IM_TRANSACTION_DEPENDENT + `/${id}`, data);
};

export const deleteim_transaction_dependent = (id) => {
  return httpClient.delete(server.IM_TRANSACTION_DEPENDENT + `/${id}`);
};
